const scrollTo = (id) => {
  const el = document.querySelector(id);
  if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
};

const roleDetails = {
  'Founder & CEO': {
    specialty: 'Leadership & Strategy',
    icon: 'fa fa-star',
  },
  'Co-Founder & Director of Operations': {
    specialty: 'Operations & Client Success',
    icon: 'fa fa-cogs',
  },
  'Chief HVAC Engineer': {
    specialty: 'Technical Excellence',
    icon: 'fa fa-wrench',
  },
};

export const Team = (props) => {
  return (
    <section id='team' style={{ padding: '100px 0', background: '#fff' }}>
      <div className='container'>

        {/* ── Section Header ── */}
        <div style={{ textAlign: 'center', marginBottom: '72px' }}>
          <p style={{
            color: '#5ca9fb', fontWeight: '700',
            fontSize: '12px', letterSpacing: '3px',
            textTransform: 'uppercase', margin: '0 0 16px',
          }}>
            — Our People
          </p>
          <h2 style={{
            fontFamily: 'Raleway, sans-serif',
            fontSize: 'clamp(32px, 4vw, 52px)',
            fontWeight: '800', color: '#0f0f1a',
            lineHeight: '1.1', margin: '0 0 20px',
          }}>
            Meet the <span style={{ color: '#5ca9fb' }}>Team</span>
          </h2>
          <p style={{
            color: '#888', fontSize: '16px',
            maxWidth: '500px', margin: '0 auto',
            lineHeight: '1.75',
          }}>
            The certified professionals behind ACTECH's reputation for excellence — passionate, experienced, and always ready to serve.
          </p>
        </div>

        {/* ── Team Cards ── */}
        <div className='team-grid'>
          {props.data
            ? props.data.map((d, i) => {
                const detail = roleDetails[d.job] || { specialty: 'HVAC Professional', icon: 'fa fa-user' };
                return (
                  <div
                    key={`${d.name}-${i}`}
                    className='team-card'
                    style={{
                      background: '#fff',
                      border: '1px solid #eef0ff',
                      borderRadius: '24px',
                      padding: '40px 28px 32px',
                      textAlign: 'center',
                      position: 'relative',
                      overflow: 'hidden',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease',
                    }}
                    onMouseEnter={e => {
                      e.currentTarget.style.transform = 'translateY(-8px)';
                      e.currentTarget.style.boxShadow = '0 24px 60px rgba(92,169,251,0.15)';
                      e.currentTarget.style.borderColor = 'rgba(92,169,251,0.35)';
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = 'none';
                      e.currentTarget.style.borderColor = '#eef0ff';
                    }}
                  >
                    {/* Background decorative circle */}
                    <div style={{
                      position: 'absolute',
                      top: '-40px', right: '-40px',
                      width: '160px', height: '160px',
                      borderRadius: '50%',
                      background: 'radial-gradient(circle, rgba(92,169,251,0.07) 0%, transparent 70%)',
                      pointerEvents: 'none',
                    }} />

                    {/* Gradient ring + photo */}
                    <div style={{
                      width: '150px', height: '150px',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #5ca9fb, #6372ff)',
                      padding: '4px',
                      margin: '0 auto 24px',
                      boxShadow: '0 8px 32px rgba(92,169,251,0.3)',
                    }}>
                      <div style={{
                        width: '100%', height: '100%',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        background: '#f0f4ff',
                      }}>
                        <img
                          src={d.img}
                          alt={d.name}
                          style={{
                            width: '100%', height: '100%',
                            objectFit: 'cover',
                            objectPosition: 'center top',
                            display: 'block',
                          }}
                        />
                      </div>
                    </div>

                    {/* Name */}
                    <h3 style={{
                      fontFamily: 'Raleway, sans-serif',
                      fontSize: '20px', fontWeight: '800',
                      color: '#0f0f1a',
                      margin: '0 0 8px',
                    }}>
                      {d.name}
                    </h3>

                    {/* Job title badge */}
                    <div style={{
                      display: 'inline-block',
                      background: 'linear-gradient(to right, rgba(92,169,251,0.12), rgba(99,114,255,0.12))',
                      border: '1px solid rgba(92,169,251,0.25)',
                      borderRadius: '20px',
                      padding: '5px 14px',
                      color: '#5ca9fb',
                      fontSize: '12px',
                      fontWeight: '700',
                      letterSpacing: '0.3px',
                      marginBottom: '24px',
                    }}>
                      {d.job}
                    </div>

                    {/* Divider */}
                    <div style={{
                      width: '40px', height: '2px',
                      background: 'linear-gradient(to right, #5ca9fb, #6372ff)',
                      borderRadius: '2px',
                      margin: '0 auto 20px',
                    }} />

                    {/* Specialty row */}
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '7px',
                      color: '#888',
                      fontSize: '13px',
                      fontWeight: '600',
                      marginBottom: '28px',
                    }}>
                      <i
                        className={detail.icon}
                        style={{
                          color: '#5ca9fb', fontSize: '13px',
                          display: 'inline', width: 'auto', height: 'auto',
                          padding: 0, background: 'none', boxShadow: 'none',
                          borderRadius: 0, margin: 0, lineHeight: 1, transition: 'none',
                        }}
                      ></i>
                      {detail.specialty}
                    </div>

                    {/* CTA */}
                    <a
                      href='#contact'
                      onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        background: '#f4f7ff',
                        border: '1px solid #dde5ff',
                        borderRadius: '50px',
                        padding: '9px 20px',
                        color: '#5ca9fb',
                        fontSize: '12px',
                        fontWeight: '700',
                        textDecoration: 'none',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        transition: 'background 0.2s, border-color 0.2s',
                      }}
                      onMouseEnter={e => {
                        e.currentTarget.style.background = 'linear-gradient(to right, #5ca9fb, #6372ff)';
                        e.currentTarget.style.borderColor = 'transparent';
                        e.currentTarget.style.color = '#fff';
                      }}
                      onMouseLeave={e => {
                        e.currentTarget.style.background = '#f4f7ff';
                        e.currentTarget.style.borderColor = '#dde5ff';
                        e.currentTarget.style.color = '#5ca9fb';
                      }}
                    >
                      Get in Touch
                    </a>
                  </div>
                );
              })
            : 'Loading...'}
        </div>

        {/* ── Hiring CTA Strip ── */}
        <div style={{
          marginTop: '72px',
          background: 'linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 100%)',
          borderRadius: '20px',
          padding: '48px 40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '28px',
          flexWrap: 'wrap',
        }}>
          <div>
            <p style={{
              color: '#5ca9fb', fontWeight: '700',
              fontSize: '11px', letterSpacing: '3px',
              textTransform: 'uppercase', margin: '0 0 10px',
            }}>
              — We're Growing
            </p>
            <h3 style={{
              fontFamily: 'Raleway, sans-serif',
              fontSize: 'clamp(20px, 2.5vw, 28px)',
              fontWeight: '800', color: '#fff',
              margin: '0 0 8px', lineHeight: '1.2',
            }}>
              Join the ACTECH Team
            </h3>
            <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: '14px', margin: 0, maxWidth: '420px' }}>
              We're expanding our network of certified HVAC engineers. Join us and get connected with commercial clients across Lagos.
            </p>
          </div>
          <a
            href='https://apply.actech.com.ng'
            className='team-hire-btn'
            style={{
              display: 'inline-flex', alignItems: 'center', gap: '8px',
              background: 'linear-gradient(to right, #5ca9fb, #6372ff)',
              color: '#fff', padding: '14px 32px', borderRadius: '50px',
              textDecoration: 'none', fontWeight: '700', fontSize: '13px',
              textTransform: 'uppercase', letterSpacing: '0.5px',
              boxShadow: '0 8px 24px rgba(92,169,251,0.4)',
              whiteSpace: 'nowrap',
            }}
          >
            <i className='fa fa-users'></i> Apply Now
          </a>
        </div>

      </div>

      <style>{`
        .team-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
        }

        /* Reset FA icon blobs */
        #team .team-hire-btn i.fa {
          font-size: 14px !important;
          width: auto !important;
          height: auto !important;
          padding: 0 !important;
          border-radius: 0 !important;
          background: none !important;
          box-shadow: none !important;
          margin-bottom: 0 !important;
          color: inherit !important;
          display: inline !important;
          transition: none !important;
          line-height: inherit !important;
        }

        @media (max-width: 900px) {
          .team-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }

        @media (max-width: 560px) {
          .team-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
};
